import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Scroll reveal animations
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible")
        observer.unobserve(entry.target)
      }
    })
  },
  { threshold: 0.15 }
)

document.querySelectorAll(".reveal").forEach((el) => observer.observe(el))

// Post table of contents
const toc = document.querySelector(".post-toc-list")
if (toc) {
  const headings = document.querySelectorAll(".post-body h2")
  if (headings.length > 0) {
    headings.forEach((heading, i) => {
      const id = heading.id || `section-${i}`
      heading.id = id
      const li = document.createElement("li")
      const a = document.createElement("a")
      a.href = `#${id}`
      a.textContent = heading.textContent
      li.appendChild(a)
      toc.appendChild(li)
    })
  } else {
    document.querySelector(".post-toc").style.display = "none"
  }
}

// Blog tag filtering
const tagButtons = document.querySelectorAll(".tag-btn")
const postCards = document.querySelectorAll(".post-card[data-tags]")

tagButtons.forEach((btn) => {
  btn.addEventListener("click", () => {
    const tag = btn.dataset.tag

    tagButtons.forEach((b) => b.classList.remove("active"))
    btn.classList.add("active")

    postCards.forEach((card) => {
      if (tag === "all") {
        card.classList.remove("hidden")
      } else {
        const tags = card.dataset.tags.split(",")
        card.classList.toggle("hidden", !tags.includes(tag))
      }
    })
  })
})
